import { E_AGENCY_INTEGRATION } from "../enums/AgencyIntegration";
import { ERequestMethods } from "../enums/RequestMethod";
import { request } from "../libs/request";
import { IGoogleCallbackData } from "../types/AgencyIntegration";
import { EIntegrationType } from "../types/AgencyIntegration";
import { IResponseData } from "../types/requests";
import { IIntegration } from "../types/AgencyIntegration";

function getAgencyIntegratedByType(type: EIntegrationType) {
  return request<IResponseData<IIntegration>>({
    method: ERequestMethods.GET,
    url: E_AGENCY_INTEGRATION.GET_BY_TYPE(type),
  });
}

function updateGoogleCallback(data: IGoogleCallbackData) {
  return request({
    method: ERequestMethods.POST,
    url: E_AGENCY_INTEGRATION.GOOGLE_CALLBACK,
    data,
  });
}

function disconnectIntegration(id: string, type: EIntegrationType) {
  return request({
    method: ERequestMethods.PUT,
    url: E_AGENCY_INTEGRATION.DISCONNECTED,
    data: {
      id,
      type,
    },
  });
}

function syncAllLeads() {
  return request({
    method: ERequestMethods.POST,
    url: E_AGENCY_INTEGRATION.SYNC_ALL_LEADS,
  });
}

const AgencyIntegrateRepository = Object.freeze({
  getAgencyIntegratedByType,
  updateGoogleCallback,
  disconnectIntegration,
  syncAllLeads,
});

export default AgencyIntegrateRepository;
